export const SUPPORTED_LOCALES = ['en', 'de', 'it', 'es'];
export const DEFAULT_LOCALE = 'en';

export const isSupportedLocale = (locale) => SUPPORTED_LOCALES.includes(locale);

const normalizePathname = (pathname = '/') => {
  if (!pathname) {
    return '/';
  }

  return pathname.startsWith('/') ? pathname : `/${pathname}`;
};

export const getLocaleFromPath = (pathname = '/') => {
  const normalizedPath = normalizePathname(pathname);
  const [firstSegment] = normalizedPath.split('/').filter(Boolean);

  if (isSupportedLocale(firstSegment)) {
    return firstSegment;
  }

  return DEFAULT_LOCALE;
};

export const stripLocaleFromPath = (pathname = '/') => {
  const normalizedPath = normalizePathname(pathname);
  const pathSegments = normalizedPath.split('/').filter(Boolean);

  if (pathSegments.length === 0) {
    return '/';
  }

  if (isSupportedLocale(pathSegments[0])) {
    const remainingPath = pathSegments.slice(1).join('/');
    return remainingPath ? `/${remainingPath}` : '/';
  }

  return normalizedPath;
};

export const withLocalePath = (pathname = '/', locale = DEFAULT_LOCALE) => {
  const targetLocale = isSupportedLocale(locale) ? locale : DEFAULT_LOCALE;
  const pathWithoutLocale = stripLocaleFromPath(pathname);

  if (pathWithoutLocale === '/') {
    return `/${targetLocale}`;
  }

  return `/${targetLocale}${pathWithoutLocale}`;
};
